import styled from 'styled-components';
import Tabs from '../../Tabs';

const StyledTabs = styled(Tabs)`
  top: ${({ theme }) => theme.spacing(2)};
  height: 30px;
  background-color: transparent;
`;

export default StyledTabs;
